export const CODE_SYSTEM_KEYS_VOLTAGE = ['Voltage_L1-L3', 'Voltage_L1-PE', 'Voltage_L3-PE']
